/**
* @ngdoc directive
* @name Export To Excel
*
* @description
  Export to excel button.
  To make this feature work, you must use the following markup:
  * <table>...</table>
  * <table-view></table-view> directive
  * custom:
    - add js-export-th class to table headers
    - add js-export-tr class to table rows
    - add js-export-td class to table cells
    - add js-export-general class to table cell which has text that should be imported with general type
  * add js-export-report-name class to element with report name
  * add js-export-subtitle class to element with report subtitle
*
* @scope
* @param {Boolean} isDisabled - disable button
* @param {Number} firstColumnWidth - optional first column width
*
* @attributes
* @param {String} tableName - optional id of the table to export
*
* @example
  <export-to-excel first-column-width='200'></export-to-excel>
  <div id='reportTable'>
    <div class='js-export-report-name'>Test Report</div>
    <div class='js-export-subtitle'>Test Subtitle</div>
    <table>
      <thead>
        <th>Header</th>
        <th>Header 2</th>
      </thead>
      <tbody>
        <tr>
          <td>Table Cell</td>
          <td>Table Cell 2</td>
        </tr>
      </tbody>
    </table>
  </div>
*/

(function () {
  'use strict';


  exportToExcel.$inject = ["$http", "MICROSERVICES", "localStorageService", "userDataGAService"];
  app.directive('exportToExcel', exportToExcel);

  function exportToExcel($http, MICROSERVICES, localStorageService, userDataGAService) {
    var directive = {
      restrict: 'E',
      template: '<button download="report.xls" ng-click="doExport()" class="btn btn-default mod-export" ng-disabled="isDisabled">' +
                  '<div style="display: flex; align-items: center; height: 20px;">' +
                    '<span class="icon-export"></span>' +
                    '<span class="export-text"><span class="mod-settings-selector">Export to </span>Excel</span>' +
                  '</div>' +
                '</button>',
      scope: {
        isDisabled: '=',
        firstColumnWidth: '@?'
      },
      link: function (scope, element, $attributes) {
        element.find('[data-toggle="tooltip"]').tooltip();

        scope.doExport = function () {
          var data = parseTable($attributes.tableName || 'reportTable', scope.firstColumnWidth);

          $http.post(MICROSERVICES.excel, data, { withCredentials: false })
            .then(function (res) {
              var a = document.createElement('a');
              var myBlob = dataURItoBlob('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + res.data.data);
              a.href = URL.createObjectURL(myBlob);
              a.download = res.data.file;
              document.body.appendChild(a);
              a.click();
            })
          .then(function () {
            userDataGAService.sendGAEvent({
              eventCategory: 'exportPdfExcel',
              eventAction: 'exportToExcel',
              eventValue: 'excel downloaded',
              additional: true
            });
          });
        };
      }
    };

    return directive;

    function parseTable(id, firstColumnWidth) {
      var typeSelector = $('.js-export-report-name').length ? $('.js-export-report-name') : $('.breadcrumb li.active span');
      var reportType = typeSelector.text().replace('\n', '').trim();
      var $table = $('#' + id);

      var ABC = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

      function cellName(index) {
        var x = Math.floor(index / 26);
        var tail = index % 26;
        var r = '';
        if (x > 0) {
          r += cellName(x - 1);
        }
        r += ABC[tail];
        return r;
      }

      var fileName = '';
      var workSheet = {};
      var reportInfo;
      var colsProperties = [];
      var rowIterator = 1;
      var headCellsSelectors = 'thead tr th, .js-export-th, .table-view__header-cell';
      var rowSelectors = 'tbody tr, .js-export-tr';
      var rowCellsSelectors = 'td, .js-export-td, .table-view__row-cell';
      var isTableMarkup = document.getElementById(id) && document.getElementById(id).rows;
      var isTableView = !isTableMarkup && $('.table-view').length;

      fileName = $('[data-export-report-file-name]').length ? $('[data-export-report-file-name]').attr('data-export-report-file-name') : generateFileName();
      reportInfo = generateReportInfo();

      var userInfo = localStorageService.get('userInfo');
      fileName += '_' + userInfo.currentStore.id;
      workSheet['A1'] = {
        v: userInfo.company.caption,
        t: 's',
        bold: true
      };

      rowIterator++;
      workSheet['A2'] = {
        v: reportInfo,
        t: 's',
        bold: true
      };
      rowIterator++;

      workSheet['A3'] = {
        v: userInfo.currentStore.contact ? userInfo.currentStore.contact.address : userInfo.login,
        t: 's'
      };
      rowIterator += 2;

      $table.find(headCellsSelectors).each(function (i, th) {
        addCell(th, i, true, rowIterator);
      });

      function generateFileName() {
        var reportTypeName = reportType.split(' ').join('_');
        var dates = parseDates();

        if (dates.length > 1) {
          reportTypeName += '_' + dates[0] + '-' + dates.pop();
        } else if (dates.length) {
          reportTypeName += '_' + dates[0];
        }
        return reportTypeName;
      }

      function generateReportInfo() {
        var subtitle = jQuery('.js-export-subtitle').text();
        if (subtitle) {
          return reportType + ' ' + subtitle;
        }
        var dates = parseDates('full');
        var range = dates[0] || '';
        if (dates.length > 1) {
          range += ' - ' + dates.pop();
        } else if (!range.length) {
          if (jQuery('[data-report-start-date]') && jQuery('[data-report-end-date]')) {
            var start = jQuery('[data-report-start-date]').attr('data-report-start-date');
            var end = jQuery('[data-report-end-date]').attr('data-report-end-date');
            range += [start, end].join(' - ');
          } else {
            var start = jQuery('[data-type="custom-date-range-from"]');
            if (!start.length) {
              start = jQuery('[name="daterangepicker_start"]').last();
            }
            if (start.length) range += start.val();

            var end = jQuery('[data-type="custom-date-range-to"]');
            if (!end.length) {
              end = jQuery('[name="daterangepicker_end"]').last();
            }
            if (end.length) range += ' - ' + end.val();
          }
        }

        return reportType + ' ' + range;
      }


      function parseDates(type) {
        var dateRange = [];
        var value;
        var dateFormated;

        $table.find(headCellsSelectors).each(function (i, th) {
          dateFormated = '';
          value = $(th).text().replace('\n', '').trim();
          dateFormated = getDateRange(value, type);
          if (dateFormated) dateRange.push(dateFormated);
        });
        return dateRange;
      }


      function getDateRange(value, type) {
        var date;
        if (/[A-Za-z]+\s\d+/.test(value)) {
          if (type === 'full') {
            date = value;
          }
          else {
            date = moment(value, 'MMM YYYY').format('MMYY');
          }
          return date;
        } else if (/\d+\/\d+\/\d+/.test(value)) {
          if (type === 'full') {
            date = value;
          }
          else {
            date = moment(value, 'MM/DD/YY').format('MMDDYY');
          }
          return date;
        }
      }

      if (!isTableView) {
        $table.find(rowSelectors).each(function (k, tr) {
          if (k > 0 && $(tr).find('td.break-td,td.category-head').length > 0) {
            rowIterator++;
          }
          if ($(tr).text().replace('\n', '').trim() === '') {
            return;
          }
          rowIterator++;
          $(tr).find(rowCellsSelectors).each(function (i, td) {
            addCell(td, i, false, rowIterator);
          });
        });
      } else {
        var cells = $table.find('.table-view__row-value');
        var rowsInAColumn = cells.length / colsProperties.length;
        _.range(colsProperties.length).forEach(function (i) {
          var columnCells = cells.slice(rowsInAColumn * i, rowsInAColumn * (i + 1));
          columnCells.each(function (k, td) {
            addCell(td, i, false, k + rowIterator + 1);
          });
        });

        var footerCells = $table.find('.table-view__footer-value');
        if (footerCells.length) {
          footerCells.each(function (i, td) {
            addCell(td, i, false, rowsInAColumn + rowIterator + 1);
          });
          rowIterator += 1;
        }

        rowIterator += rowsInAColumn;
      }

      workSheet['!ref'] = 'A1:' + cellName(colsProperties.length - 1) + rowIterator;
      workSheet['!cols'] = colsProperties;

      var data = {
        sheet: reportType,
        ws: workSheet,
        fileName: fileName
      };
      return data;

      function addCell(element, i, column, rowNumber) {
        var style = window.getComputedStyle(element);
        var textValue = $(element).text().trim();
        var isBold = $(element).find('b,strong').length;
        var item = {
          v: textValue,
          t: 's'
        };
        var isGeneral = $(element).hasClass('js-export-general');

        if (isGeneral) {
          // do nothing
        } else if (/^(Jan|jan|feb|Feb|mar|Mar|may|May|apr|Apr|jul|Jul|Jun|jun|Aug|aug|Oct|oct|Sep|sep|Nov|nov|dec|Dec)\s\d{4}$/.test(textValue)) {
          // passes time periods sorted by mounth: "Jul 2016"
          // not passes: "21-Jul-16", "Jul-2016", "Jul 16"
          item.t = 'd';
          item.v = textValue;
          item.z = 'mmm-yy';
        } else if (/^\d+\/\d+\/\d+$/.test(textValue)) {
          item.t = 'd';
          item.v = textValue;
          item.z = 'm/d/yy';
        } else if (/[\d\.]+%/.test(textValue)) {
          item.t = 'n';
          item.v = numeral().unformat(textValue);
          item.z = '0.00%_)';
        } else if (/-?[\d\.,]+\.\d+/.test(textValue) && !/[\$A-Za-z]/.test(textValue)) {
          item.t = 'n';
          item.v = numeral().unformat(textValue);
          item.z = '#,##0.00_);\\(#,##0.00\\)';
        } else if (/^-?\d+$/.test(textValue)) {
          item.t = 'n';
          item.v = numeral().unformat(textValue);
          item.z = '0';
        } else if (/-?\$[\d\.,]+/.test(textValue)) {
          item.t = 'n';
          item.v = numeral().unformat(textValue);
          item.z = '\\$#,##0.00_);\\(\\$#,##0.00\\)';
        }

        if (isBold || style.fontWeight == 'bold' || style.fontWeight > 400) {
          item.bold = true;
        }
        if (style.textAlign == 'right' && item.type != 'n') {
          item.alignRight = true;
        }
        if (style.borderTopStyle !== 'none') {
          item.border = true;
        }
        workSheet[cellName(i) + rowNumber] = item;

        if (column) {
          var isTotalCell = (textValue === 'Total' || (i !== 0 && element.firstElementChild && element.firstElementChild.tagName === 'B'));
          var cellWidth = 11;
          // first column width=20, total=12, else 11
          if (i === 0) cellWidth = firstColumnWidth || 20;
          else if (isTotalCell) cellWidth = 12;
          colsProperties.push({ wch: cellWidth });
        }
      }
    }

    function dataURItoBlob(dataURI) {
      // convert base64 to raw binary data held in a string
      // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
      var byteString = atob(dataURI.split(',')[1]);

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

      // write the bytes of the string to an ArrayBuffer
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      // write the ArrayBuffer to a blob, and you're done
      var bb = new Blob([ab], {
        type: 'application/octet-stream'
      });
      return bb;
    }
  }
}());



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/exportToExcel.js